import { Datagrid, List, TextField } from 'react-admin';
import { AppDocumentsCommandPanel } from './AppDocumentsCommandPanel';
import { downloadFile } from '@/util/genericCSVExporter';

export const AppDocumentsList = () => (
  <List
    resource="appDocuments"
    queryOptions={{ meta: { raw: true } }}
    exporter={documentsJsonExporter}
  >
    <Datagrid
      bulkActionButtons={false}
      expand={AppDocumentsCommandPanel}
    >
      <TextField source="id" />
      <TextField source="title" />
    </Datagrid>
  </List>
);

const documentsJsonExporter = async (documents: any[]) => {
  const data = documents.map(document => ({
    _id: document.id,
    title: document.title,
    content: document.content,
  }));

  downloadFile(JSON.stringify(data, null, 2), 'appDocuments.json');
};
